import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

const KOPIERT = "In die Zwischenablage kopiert";

// Knopf statt div (#178). Die Erfolgsmeldung steht zusaetzlich in einem
// Statusbereich, damit ein Screenreader sie hoert, ohne dass der Fokus wandert.
// Ein Statusbereich sagt nur Aenderungen an: je Kopieren wird die Meldung
// geleert und danach neu gesetzt, sonst blieb jedes weitere Kopieren stumm (#236).
const ResultsCopyClipboardButton = () => {
  const [kopiervorgaenge, setKopiervorgaenge] = useState(0);
  const [ansage, setAnsage] = useState("");

  useEffect(() => {
    if (kopiervorgaenge > 0) setAnsage(KOPIERT);
  }, [kopiervorgaenge]);

  const kopiert = () => {
    setAnsage("");
    setKopiervorgaenge(n => n + 1);
  };

  return (
    <>
      <CopyToClipboard
        text={window.location.toString()}
        onCopy={kopiert}
      >
        <button type="button" className={"jm-action-button jm-copy-btn" + (kopiervorgaenge > 0 ? " success" : "")}>
          {kopiervorgaenge > 0
            ? KOPIERT
            : "In die Zwischenablage kopieren"}
        </button>
      </CopyToClipboard>

      <span role="status" className="jm-sr-only">
        {ansage}
      </span>
    </>
  );
};

export default ResultsCopyClipboardButton;
